// extracted by mini-css-extract-plugin
module.exports = {"element":"_0fce717cdb--element--NS_NR"};